var _ellipse, _rect, _circle, _circle2, _rect2, _circle3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTickCreditCard = function SvgTickCreditCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 116,
    viewBox: "0 0 115 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 59.8288,
    cy: 105.249,
    rx: 37.321,
    ry: 1.99934,
    fill: "url(#paint0_linear_604_6800)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.745,
    y: 45.2586,
    width: 46.6513,
    height: 74.642,
    rx: 7.08069,
    transform: "rotate(108.2 102.745 45.2586)",
    fill: "url(#paint1_linear_604_6800)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5556,
    cy: 72.7046,
    r: 5.99802,
    transform: "rotate(108.2 71.5556 72.7046)",
    fill: "#BBDEFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4199,
    cy: 75.6199,
    r: 5.99802,
    transform: "rotate(108.2 80.4199 75.6199)",
    fill: "#BBDEFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5068,
    y: 32.0766,
    width: 74.642,
    height: 9.33025,
    transform: "rotate(18.1998 28.5068 32.0766)",
    fill: "#90CAF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 27.5,
    r: 17.75,
    fill: "#42A5F5",
    stroke: "white",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 28L27.6612 32.5L37 23.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_6800",
    x1: 105.632,
    y1: 103.516,
    x2: 103.899,
    y2: 117.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_604_6800",
    x1: 102.745,
    y1: 65.6963,
    x2: 146.51,
    y2: 97.2461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTickCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tick-credit-card.c62a40df8bf28295b3a8ce8f241955fd.svg";